// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2eS4E","label":"CategoryService_label__1SjQu","location":"CategoryService_location__1JdKs"};